import CenterMark from "./CenterMark";
import React from 'react';
import CustomMarker from './CustomMarker';
import DrawToolBar from "./TerraDraw/DrawToolBar";

const { compose, withProps, lifecycle } = require("recompose");
const { SearchBox } = require("react-google-maps/lib/components/places/SearchBox");
const { withScriptjs, withGoogleMap, GoogleMap, Marker, Circle, KmlLayer } = require("react-google-maps");
const API_KEY = process.env.MIX_GOOGLE_MAPS_API_KEY;
const MAP_ID = process.env.MIX_GOOGLE_MAPS_MAP_ID;
const mapUrl = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&v=beta&libraries=geometry,drawing,places,visualization,marker`;


const renderCustomMarkers = (empreendimentos, tipo, onClick) => {
    if (!Array.isArray(empreendimentos)) return null;
    return empreendimentos.map((empreendimento, index) => {
        const isResale = tipo === 'resale' && empreendimento.tipo_negocio.toLowerCase() !== "aluguel";
        const isLocation = tipo === 'location' && empreendimento.tipo_negocio.toLowerCase() !== "venda";
        if (isResale || isLocation) {
            const icon = empreendimento.customMarker || empreendimento.marker;
            return (
                <CustomMarker
                    key={`${tipo}_${empreendimento._id}_${index}`}
                    onClick={() => onClick(empreendimento._id)}
                    empreendimento={empreendimento}
                    icon={icon}
                    position={{
                        lat: empreendimento.location.coordinates[1],
                        lng: empreendimento.location.coordinates[0]
                    }}
                />
            );
        }
        return null;
    });
};


const MapWithADrawingManager = compose(
    withProps({
        googleMapURL: mapUrl,
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ minHeight: `400px`, height: '90vh' }} />,
        mapElement: <div style={{ height: `100%` }} />,
    }),
    lifecycle({
        componentDidMount() {
            var refs = {}

            var fillColor = this.props.getColor();

            this.setState({
                zoom: 13,
                fillColor: fillColor,
                mapId: MAP_ID,
                markers: [],
                onMapMounted: ref => {
                    window.googleMap = ref;
                    refs.map = ref;
                },
                handleOverlayComplete(e) {
                    this.setDrawingMode(null);
                },
                onBoundsChanged: () => {
                    this.setState({
                        bounds: refs.map.getBounds(),
                        center: refs.map.getCenter(),
                    })
                },
                onSearchBoxMounted: ref => {
                    refs.searchBox = ref;
                },
                markerComplete: (marker, fn) => {

                    let circle = new window.google.maps.Circle({
                        center: marker.getPosition(),
                        radius: this.props.raio,
                    });

                    refs.map.panTo(marker.getPosition());
                    circle.setMap(null);

                    refs.map.center = marker.getPosition();

                    this.setState({ zoom: 15 });

                    fn(marker, refs.map);

                },
                circleComplete: (circle) => {
                    circle.setOptions({ fillColor: this.props.getColor() });

                    this.props.onCircleComplete(circle);

                },

                onPlacesChanged: () => {
                    const place = refs.searchBox.getPlaces();
                    refs.map.panTo(place[0].geometry.location);

                    this.props.setLocation(place);

                    this.setState({ zoom: 12, })

                },
            })
        },
    }),
    withScriptjs,
    withGoogleMap
)(props => {


    return (
        <GoogleMap
            defaultZoom={13}
            zoom={props.zoom}
            ref={props.onMapMounted}
            onBoundsChanged={props.onBoundsChanged}
            defaultCenter={new google.maps.LatLng(props.currentPosition.lat, props.currentPosition.lng)}
            defaultOptions={
                {
                    mapTypeControlOptions: {
                        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                        position: google.maps.ControlPosition.TOP_RIGHT
                    },

                    fullscreenControlOptions: {
                        position: google.maps.ControlPosition.BOTTOM_RIGHT,
                    },
                    mapId: MAP_ID,
                }
            }
        >
            {props.kml_layers.map((kml, index) => {
                if (props.showKMl === true) {
                    return <KmlLayer key={kml}
                        url={kml}
                        options={{ preserveViewport: true }}
                    />
                }
            })}


            {props.showResaleMarkers && renderCustomMarkers(props.revendaLocacao || [], 'resale', props.onRevendaMarkerClick)}
            {props.showLocationMarkers && renderCustomMarkers(props.revendaLocacao || [], 'location', props.onRevendaMarkerClick)}

            {(props.pontos || []).map((marker, index) => (
                <CenterMark
                    key={index}
                    onClick={() => {
                        props.onCenterMarkClick({ lat: marker.lat, lng: marker.lng });
                    }}
                    position={{ lat: marker.lat, lng: marker.lng }}
                />
            ))}

            {!props.hide_search_box && <React.Fragment>

                <div className="d-flex justify-content-center align-items-center">
                    <DrawToolBar

                        onMarkerComplete={(marker) => {
                            props.markerComplete(marker, props.onMarkerComplete);
                            marker.setMap(null);
                        }}
                        onPolygonComplete={(polygon) => {
                            polygon.setOptions({
                                fillColor: props.getColor(),
                                color: props.getColor(),
                            });

                            props.onPolygonComplete(polygon)
                        }}
                        onCircleComplete={props.circleComplete}
                        onRectangleComplete={(rectangle) => {

                            rectangle.setOptions({
                                fillColor: props.getColor(),
                                color: props.getColor()
                            });

                            props.onRectangleComplete(rectangle)
                        }}
                        setDrawing={props.setDrawing}

                    />

                    <SearchBox
                        ref={props.onSearchBoxMounted}
                        bounds={props.bounds}
                        controlPosition={google.maps.ControlPosition.TOP_CENTER}
                        onPlacesChanged={props.onPlacesChanged}
                    >
                        <React.Fragment>
                            <input
                                type="text"
                                placeholder="Digite um endereço"
                                id="search_box"
                                style={{
                                    marginLeft: '30px',
                                    boxSizing: `border-box`,
                                    border: `1px solid #cccccc`,
                                    width: `40%`,
                                    height: `30px`,
                                    marginTop: `3px`,
                                    padding: `0 12px`,
                                    borderRadius: `3px`,
                                    boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                                    fontSize: `14px`,
                                    outline: `none`,
                                    textOverflow: `ellipses`,
                                    background: `rgba(255, 255, 255, 0.8)`,
                                }}
                            />
                        </React.Fragment>
                    </SearchBox>
                </div>
            </React.Fragment>}
        </GoogleMap>
    )
});

export default MapWithADrawingManager;
